import { render } from "./Facturacion.vue?vue&type=template&id=db705720&scoped=true"
import script from "./Facturacion.vue?vue&type=script&lang=js"
export * from "./Facturacion.vue?vue&type=script&lang=js"

import "./Facturacion.vue?vue&type=style&index=0&id=db705720&scoped=true&lang=css"

import exportComponent from "D:\\GIT\\Interfaz_Colecturia\\colecturia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db705720"]])

export default __exports__